import React from "react"
import { promotionsData } from "../../data/PromotionData"
import { useLeaderboard } from "../../data/LeaderboardProvider"

export default function ModuleFlexiShowDown({ closeModal }) {
  const promoData = promotionsData.find(
    (promo) => promo.title === "Flexi-Spin Showdown"
  )

  const {
    leaderboardData,
    loading,
    getBonusByRank,
    playerPosition,
    loadingBoard,
  } = useLeaderboard()

  return (
    <div className="promotion-module-pop-container">
      <div className="promotion-module-container">
        <button onClick={closeModal} className="promotion-close-btn">
          Close
        </button>

        <div className="promotion-module-main">
          <div className="promotion-leaderboard">
            <div className="promotion-module-banner">
              <img src={promoData.imgSrc} alt="Promotion Banner" />
              <div className="img-overlay"></div>
            </div>

            <div className="king-of-reel-title">
              Flexi-Spin Showdown Leaderboard
            </div>

            <table className="promotion-module-table" style={{ marginTop: 5 }}>
              <thead>
                <tr>
                  <th>Ranking</th>
                  <th>Username</th>
                  <th>FreeBets</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3" style={{ textAlign: "center" }}>
                      Loading...
                    </td>
                  </tr>
                ) : leaderboardData.length > 0 ? (
                  leaderboardData.map((row, index) => {
                    const bonusValue = getBonusByRank(row.ranking)
                    const bonusDisplay = bonusValue
                      ? bonusValue.toLocaleString()
                      : "–"

                    return (
                      <tr key={index}>
                        <td>{row.ranking}</td>
                        <td>{row.username}</td>
                        <td>{bonusDisplay}</td>
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td colSpan="3" style={{ textAlign: "center" }}>
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="promotion-module-cta">
            <span style={{ fontSize: 13, paddingInline: 10 }}>
              {loadingBoard ? (
                <p>Loading leaderboard...</p>
              ) : playerPosition ? (
                <p>You’re on the Leaderboard: Rank #{playerPosition}</p>
              ) : (
                <p>Leaderboard changes in real-time</p>
              )}
            </span>
            <a href="/slots/?provider=BNG">
              <button className="promotion-module-leaderboard-btn">
                Play Now
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
